import type { ColumnPinData } from "./ViewTable.lib";
import styles from "./ViewTable.module.scss";

/** Sticky-pin classes for any cell of a column: header, body, or placeholder. */
export function getPinClasses(
    pinData: ColumnPinData | undefined,
): Record<string, boolean> {
    return {
        [styles.pinnedLeft]: pinData?.isPinned === "left",
        [styles.pinnedRight]: pinData?.isPinned === "right",
        [styles.lastLeftColumn]: pinData?.isLastLeft ?? false,
        [styles.firstRightColumn]: pinData?.isFirstRight ?? false,
    };
}
